// TODO: Replace this URL with your deployed Google Apps Script Web App URL
export const GOOGLE_APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbx5YPgQayFkB3_RnKdB43149F2v9eAe-k7jSsQYWK8Fr5z7ch9x1FWA887Y3uKCUUFnJA/exec';

export const PIN_CODE = '100911';

export const AI_MODEL_NAME = 'gemini-3-pro-preview';
export const AI_MODEL_FLASH = 'gemini-3-flash-preview';

export const CHAT_PAGE_SIZE = 10;